import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {TasksApiPath, FEATURE_NAMESPACE} from '../../../consts'
import {ProcessWorkOrderDto, ProcessWorkOrderEditDto} from '../../../types'
import {prepareProcessWorkOrderFormData} from '../../../utils'
import {TasksQueryKey} from '../useTasks'

import {ProcessWorkOrderQueryKey} from './useProcessWorkOrder'

const INTERVAL = 400
const REPEATS = 5
export const useUpdateProcessWorkOrder = () => {
  const queryClient = useQueryClient()
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation<ProcessWorkOrderDto, AxiosError, ProcessWorkOrderEditDto>({
    mutationFn: async (data) => {
      const {id, plantId} = data

      if (!plantId || !id) {
        throw new Error('Missing plantId or id for update')
      }

      const path = `${TasksApiPath.PROCESS_WORK_ORDERS}/${plantId}/process-work-orders/${id}`

      const formData = await prepareProcessWorkOrderFormData(data, ['plantId', 'id'])

      const {data: response} = await ApiClient.axiosInstance.patch(path, formData)
      return response
    },
    onError: () => {
      spawnErrorToast(t('processWorkOrders.message.failedToUpdateProcessWorkOrder'))
    },
    onSuccess: async (data) => {
      spawnSuccessToast(t('processWorkOrders.message.processWorkOrderUpdated'))
      void queryClient.invalidateQueries({
        queryKey: [ProcessWorkOrderQueryKey, data.id, data.plantId],
        refetchType: 'all'
      })
      void queryClient.invalidateQueries({
        queryKey: [TasksQueryKey, ProcessWorkOrderQueryKey],
        refetchType: 'all'
      })
      void queryClient.invalidateQueries({queryKey: [TasksQueryKey], refetchType: 'all'})

      for (let i = 0; i < REPEATS; i++) {
        await queryClient.invalidateQueries({queryKey: [TasksQueryKey], refetchType: 'all'})
        await new Promise((resolve) => setTimeout(resolve, INTERVAL))
      }
    }
  })
}
